import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'onlyNumbers'
})
export class OnlyNumbersPipe implements PipeTransform {

  transform(value: any, ...args: unknown[]): unknown {
    if(!value) {return '';}
    return String(value).replace(/\D/g, '');
  }

}
